<template>
    <AuthLayout :loading="form.processing">
        <template #logo>
            <div class="flex justify-end items-center pb-8 ">
                <AppLogo />
            </div>
        </template>
        <div>
            <h2 class="text-2xl font-bold text-gray-800 mb-4">Reset Your Password</h2>

            <form @submit.prevent="submit" class="space-y-5">
                <div>
                    <label for="email" class="block text-sm font-medium text-gray-700 dark:text-gray-200">
                        Email
                    </label>
                    <t-input id="email" type="email" class="mt-1 block w-full" v-model="form.email" required autofocus
                        autocomplete="email" />
                </div>

                <div>
                    <label for="password" class="block text-sm font-medium text-gray-700 dark:text-gray-200">
                        New Password
                    </label>
                    <t-input id="password" type="password" class="mt-1 block w-full" v-model="form.password" required
                        autocomplete="new-password" />
                </div>

                <div>
                    <label for="password_confirmation"
                        class="block text-sm font-medium text-gray-700 dark:text-gray-200">
                        Confirm New Password
                    </label>
                    <t-input id="password_confirmation" type="password" class="mt-1 block w-full"
                        v-model="form.password_confirmation" required autocomplete="new-password" />
                </div>
                <div class="flex flex-wrap items-center justify-center gap-4 mt-4 text-center">
                    <JetButton :class="{ 'opacity-25': form.processing }" :disabled="form.processing" class="w-full justify-center px-6 py-2">
                        <span v-if="form.processing" class="animate-pulse">Processing...</span>
                        <span v-else>Reset Password</span>
                    </JetButton>
                </div>
            </form>
        </div>
    </AuthLayout>
</template>


<script>
import AuthLayout from '@/Layouts/AuthLayout.vue'
import AppLogo from '@/Components/AppLogo.vue'
import JetAuthenticationCard from '@/Jetstream/AuthenticationCard'
import JetAuthenticationCardLogo from '@/Jetstream/AuthenticationCardLogo'
import JetButton from '@/Jetstream/Button'
import JetInput from '@/Jetstream/Input'
import JetLabel from '@/Jetstream/Label'
import JetValidationErrors from '@/Jetstream/ValidationErrors'

export default {
    components: {
        AuthLayout,
        AppLogo,
        JetAuthenticationCard,
        JetAuthenticationCardLogo,
        JetButton,
        JetInput,
        JetLabel,
        JetValidationErrors
    },

    props: {
        email: String,
        token: String,
    },

    data() {
        return {
            form: this.$inertia.form({
                token: this.token,
                email: this.email,
                password: '',
                password_confirmation: '',
            })
        }
    },

    methods: {
        submit() {
            this.form.post(this.route('password.update'), {
                onFinish: () => this.form.reset('password', 'password_confirmation'),
            })
        }
    }
}
</script>
